module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(this.$route.name)))]), _vm._v(" "), _c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l((this.routes), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.name,
      attrs: {
        "to": _vm.getRouteTo(item)
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(item.name)) + "\n      ")])
  }), 1), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (this.$route.meta.button != null) ? _c('div', {
    staticClass: "button"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": this.buttonClick
    }
  }, [_vm._v(_vm._s(this.$route.meta.button.text))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7191b356","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 1170
// module chunks = 2